import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, addDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const CustomerDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  //const { companyCode, unitCode, tableId, serviceArea  } = location.state || {};

const queryParams = new URLSearchParams(location.search);

const companyCode =
  location.state?.companyCode || queryParams.get('code');

const unitCode =
  location.state?.unitCode || queryParams.get('unit');

const tableId =
  location.state?.tableId || queryParams.get('id');

const serviceArea =
  location.state?.serviceArea || queryParams.get('serviceArea');

  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
const [loading, setLoading] = useState(true);

  useEffect(() => {
  const checkExistingCart = async () => {
    //  skip if user explicitly wants new cart
    if (location.state?.forceNewCart) {
      setLoading(false);
      return;
    }

    if (!companyCode || !unitCode || !tableId) {
      setLoading(false);
      return;
    }
    
    try {

       // ✅ CHECK BILLING PREFERENCE FIRST
      const prefQuery = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Billing Process")
      );

      const prefSnapshot = await getDocs(prefQuery);

      let billing = null;

      if (!prefSnapshot.empty) {
        billing = Number(
          prefSnapshot.docs[0].data().preferenceValue
        );
      }

      console.log("Billing Preference:", billing);

      //  BILLING 0 OR 1 → DIRECT HOME
      if (billing === 0 || billing === 1) {
        navigate(
          `/customer/home?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}&isCustomer=true`,
          {
            state: {
              companyCode,
              unitCode,
              tableId,
              serviceArea,
              isCustomer: true,
            },
          }
        );

        return;
      }

      const cartsRef = collection(db, "carts");

      const q = query(
        cartsRef,
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("tableId", "==", tableId),
        where("serviceArea", "==", serviceArea)
      );

      const snapshot = await getDocs(q);

      let existingCart = null;

      snapshot.forEach(doc => {
  const data = doc.data();

  if (
    !existingCart ||
    data.updatedAt?.seconds > existingCart?.updatedAt?.seconds
  ) {
    existingCart = data;
  }
});
      console.log("CustomerDetails existingCart:", existingCart);

      if (existingCart) {
         navigate(
  `/customer/join-cart?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea || ''}`,
  {
    state: {
      existingCart,
      companyCode,
      unitCode,
      tableId,
      serviceArea
    }
  }
);
        return;
      }

     /* const profileQuery = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Profile Data")
      );

      const profileSnapshot = await getDocs(profileQuery);

      let profilePreference = 0;

      if (!profileSnapshot.empty) {
        profilePreference = Number(
          profileSnapshot.docs[0].data().preferenceValue
        );
      }

      console.log("Profile Preference:", profilePreference);

      if (profilePreference === 1) {

        // EXISTING CART → JOIN CART
        if (existingCart) {
          navigate(
            `/customer/join-cart?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea || ""}`,
            {
              state: {
                existingCart,
                companyCode,
                unitCode,
                tableId,
                serviceArea,
                isCustomer: false,
                autoJoin: true,
              },
              replace: true,
            }
          );

          return;
        }

        // NO CART → DIRECT GUEST HOME
        navigate(
          `/customer/home?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}&isCustomer=false&name=Guest`,
          {
            state: {
              companyCode,
              unitCode,
              tableId,
              serviceArea,
              isCustomer: false,
              customerName: "Guest",
              phone: null,
              autoGuest: true,
            },
            replace: true,
          }
        );

        return;
      }*/

    } catch (err) {
      console.error("Cart check error:", err);
    }

    setLoading(false);
  };

  checkExistingCart();
}, []);
  // Check if phone exists
  const handlePhoneChange = async (value) => {
    setPhone(value);

    if (value.length >= 10) {
      const q = query(
        collection(db, 'customers'),
        where('phone', '==', value)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const customerData = snapshot.docs[0].data();
        setName(customerData.name); // auto-fill
      } else {
        setName('');
      }
    }
  };


  const handleGuest = () => {
  navigate(
    `/customer/home?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}&isCustomer=false&name=Guest`,
    {
      state: {
        companyCode,
        unitCode,
        tableId,
        serviceArea,
        isCustomer: false,
        customerName: 'Guest',
        phone: null,
      },
    }
  );
};
  //Save and go to home
  const handleSave = async () => {
    if (!phone || !name) return;

    // Save only if new customer
    const q = query(
      collection(db, 'customers'),
      where('phone', '==', phone)
    );

    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      await addDoc(collection(db, 'customers'), {
        phone,
        name,
        companyCode,
        unitCode,
        createdAt: new Date(),
      });
    }

    //Navigate to home
    navigate(
  `/customer/home?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}&isCustomer=true&name=${encodeURIComponent(name)}&phone=${phone}`,
  {
    state: { 
      companyCode, 
      unitCode, 
      tableId, 
      serviceArea, 
      isCustomer: true,
      customerName: name,
      phone,
    },
  }
);
  };

  if (loading) {
  return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <Typography>Checking existing order...</Typography>
    </Box>
  );
}
  return (
    <Box sx={{ p: 4, maxWidth: 400, mx: 'auto' }}>
      <Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
  }}
>
  <Typography variant="h5">
    Enter Details
  </Typography>

  <Button
    variant="contained"
    size="small"
    
    onClick={handleGuest}
  >
    Enter as Guest
  </Button>
</Box>

      <TextField
        label="Your Mobile Number"
        fullWidth
        value={phone}
        onChange={(e) => handlePhoneChange(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Your Name"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
        sx={{ mb: 3 }}
      />

      <Button variant="contained" fullWidth onClick={handleSave}>
        Enter
      </Button>
    </Box>
  );
};

export default CustomerDetails;